// src/features/properties/PropertyGrid.jsx
import React, { useEffect, useState } from 'react';
import PropertyCard from './PropertyCard';
import { useAuth } from '../../context/AuthContext';
import { getUserFavorites } from '../../services/api';

const SkeletonCard = () => (
    <div className="bg-white dark:bg-surface-850 rounded-2xl border border-surface-100 dark:border-surface-800 shadow-sm overflow-hidden animate-pulse">
        <div className="h-52 bg-surface-100 dark:bg-surface-700" />
        <div className="p-4 space-y-3">
            <div className="h-4 bg-surface-100 dark:bg-surface-700 rounded w-3/4" />
            <div className="h-3 bg-surface-100 dark:bg-surface-700 rounded w-1/2" />
            <div className="h-3 bg-surface-100 dark:bg-surface-700 rounded w-full" />
            <div className="flex justify-between pt-3 border-t border-surface-100 dark:border-surface-800">
                <div className="h-3 bg-surface-100 dark:bg-surface-700 rounded w-16" />
                <div className="h-3 bg-surface-100 dark:bg-surface-700 rounded w-16" />
                <div className="h-3 bg-surface-100 dark:bg-surface-700 rounded w-16" />
            </div>
            <div className="h-9 bg-surface-100 dark:bg-surface-700 rounded-xl mt-2" />
        </div>
    </div>
);

const PropertyGrid = ({ propiedades, loading }) => {
    const { user, isAuthenticated } = useAuth();
    const [favIds, setFavIds] = useState([]);

    useEffect(() => {
        if (isAuthenticated && user?.id) {
            getUserFavorites(user.id).then(setFavIds).catch(() => {});
        }
    }, [isAuthenticated, user?.id]);

    if (loading) {
        return (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {[...Array(6)].map((_, i) => (
                    <SkeletonCard key={i} />
                ))}
            </div>
        );
    }

    if (!propiedades || propiedades.length === 0) {
        return (
            <div className="text-center py-20 animate-fade-in motion-reduce:animate-none">
                <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-surface-100 dark:bg-surface-800 mb-4">
                    <svg className="w-10 h-10 text-surface-400 dark:text-surface-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                    </svg>
                </div>
                <p className="text-surface-700 dark:text-surface-300 text-lg font-semibold">No se encontraron propiedades</p>
                <p className="text-surface-500 dark:text-surface-400 text-sm mt-1">Intenta con otros filtros o términos de búsqueda</p>
            </div>
        );
    }

    return (
        <>
            <p className="text-sm text-surface-500 dark:text-surface-400 mb-4 animate-fade-in motion-reduce:animate-none"><span className="font-semibold text-surface-900 dark:text-white">{propiedades.length}</span> propiedad{propiedades.length !== 1 ? 'es' : ''} encontrada{propiedades.length !== 1 ? 's' : ''}</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {propiedades.map((propiedad, index) => (
                    <div key={propiedad.id} className="animate-fade-in-up motion-reduce:animate-none" style={{ animationDelay: `${index * 55}ms` }}>
                        <PropertyCard propiedad={propiedad} isFav={favIds.includes(propiedad.id)} priority={index < 3} />
                    </div>
                ))}
            </div>
        </>
    );
};

export default PropertyGrid;
